/**
 * SR PDP UI behaviors (pairs with sr-pdp.css)
 * - Buy-box accordions (.sr-pdp-accordion--responsive): collapsed on mobile, expanded on desktop.
 * - Below-fold collapsible tabs + fit-guide row: collapsed on mobile only (desktop stays as authored).
 * - Fit guide size pill: SMALL / STANDARD / LARGE SIZE SELECTED (syncs on variant change).
 * - Yotpo stars in the SR title row (.title-row__yotpo): scroll to reviews (product.js only handles .price-container).
 * - View Size Guide link (#pdp_size_guide): smooth-scroll to that block (anchor id).
 */
(function () {
  const MQ = '(max-width: 767.98px)';

  const SELECTOR_BUY_BOX = '.sr-pdp .sr-pdp-accordion--responsive details.disclosure';
  const SELECTOR_MOBILE_ONLY = `
    .collapsible-tabs__tab--fit-guide details.disclosure,
    body.sr-pdp-pdp .section-collapsible-tabs .collapsible-tabs__tab details.disclosure
  `;

  function apply() {
    const mq = window.matchMedia(MQ);

     document.querySelectorAll(SELECTOR_BUY_BOX).forEach((details) => {
      if (mq.matches) {
        details.removeAttribute('open');
      }
    });
    document.querySelectorAll(SELECTOR_MOBILE_ONLY).forEach((details) => {
      if (mq.matches) {
        details.removeAttribute('open');
      }
    });
  }

  function fitGuideSizePillLabel(raw) {
    const s = String(raw || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
    if (!s) return '';
    if (s.includes('medium/large') || s === 'm/l') return 'STANDARD SIZE SELECTED';
    if (
      s.includes('xl') ||
      s.includes('extra large') ||
      (s.includes('large') && !s.includes('small') && !s.includes('medium'))
    ) {
      return 'LARGE SIZE SELECTED';
    }
    if (s.includes('small') && !s.includes('medium') && !s.includes('large')) {
      return 'SMALL SIZE SELECTED';
    }
    return 'STANDARD SIZE SELECTED';
  }

  function syncFitGuideSizePills() {
    if (!document.body.classList.contains('sr-pdp-pdp')) return;
    
    const pills = document.querySelectorAll('[data-fit-guide-size-pill]');
    if (pills.length === 0) return;

    // Check if the size option exists on the product at all
    const sizeOptionExists = !!document.querySelector('.js-product [data-option-name="size"]');
    const sizeInput = document.querySelector('.js-product input[data-option-name="size"]:checked');

    // If size option doesn't exist or no size is selected, hide the pills
    if (!sizeOptionExists || !sizeInput) {
      pills.forEach((el) => {
        el.textContent = '';
        el.hidden = true;
        el.style.display = 'none'; // Ensure physical removal from layout
      });
      return;
    }

    const raw = sizeInput.dataset.optionValue || sizeInput.value || '';
    const label = fitGuideSizePillLabel(raw);
    
    pills.forEach((el) => {
      if (!label) {
        el.textContent = '';
        el.hidden = true;
        el.style.display = 'none';
      } else {
        el.textContent = label;
        el.hidden = false;
        el.style.display = ''; // Restore default display
      }
    });
  }

  function fitGuideSubheadLabel(raw) {
    const s = String(raw || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
    if (!s) return '';
    if (s.includes('xl') || s.includes('extra large')) return 'EXTRA LARGE FIT';
    if (s.includes('small')) return 'SMALL TO MEDIUM FIT';
    return 'MEDIUM TO LARGE FIT';
  }

  function syncSrFitGuideHead() {
    if (!document.body.classList.contains('sr-pdp-pdp')) return;

    const head = document.querySelector('.sr-fit-guide-section__card .sr-fit-guide-section__head');
    if (!head) return;

    const sub = head.querySelector('[data-sr-fit-guide-subhead]');
    const lede = head.querySelector('[data-sr-fit-guide-lede]');
    if (!sub || !lede) return;

    const sizeInput = document.querySelector('.js-product input[data-option-name="size"]:checked');
    const raw = sizeInput?.dataset?.optionValue || sizeInput?.value || '';

    sub.textContent = fitGuideSubheadLabel(raw);
    lede.textContent = 'Designed to fit most, this frame is a great option for universal appeal and comfort.';
  }

  function initFitGuidePill() {
    syncFitGuideSizePills();
    syncSrFitGuideHead();
    document.addEventListener('on:variant:change', syncFitGuideSizePills);
    document.addEventListener('on:variant:change', syncSrFitGuideHead);
  }

  function scrollToYotpoReviewsSection() {
    const target =
      document.getElementById('yotpo-app') ||
      document.getElementById('yotpo-reviews-main-widget') ||
      document.querySelector('.yotpo-reviews-main-widget');
    if (!target) return false;
    const headerOffset =
      (document.querySelector('.pageheader--sticky') &&
        document.querySelector('.section-header')?.offsetHeight) ||
      100;
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top, behavior: 'smooth' });
    return true;
  }

  /** Title-row / SR price Yotpo widgets (product.js only wires .price-container). */
  function initYotpoTitleRowReviewsScroll() {
    function tryScroll() {
      if (scrollToYotpoReviewsSection()) return;
      const t = setInterval(() => {
        if (scrollToYotpoReviewsSection()) clearInterval(t);
      }, 200);
      setTimeout(() => clearInterval(t), 8000);
    }

    function onActivate(e) {
      const inTitleRow = e.target.closest(
        '.title-row__yotpo a, .title-row__yotpo .yotpo-sr-bottom-line-summary, .title-row__yotpo .yotpo-bottomline, .title-row__yotpo .yotpo-widget-instance'
      );
      const inSrPrice = e.target.closest(
        '.sr-pdp-price-container .yotpo-sr-bottom-line-summary, .sr-pdp-price-container .yotpo-bottomline'
      );
      if (!inTitleRow && !inSrPrice) return;
      const onSrPdp =
        document.body.classList.contains('sr-pdp-pdp') ||
        document.querySelector('#product_wrapper-container.sr-pdp');
      if (!onSrPdp) return;
      e.preventDefault();
      tryScroll();
    }

    document.addEventListener('click', onActivate, true);
  }

  /** Smooth-scroll to fit guide block (ids: pdp_size_guide, pdp-size-guide). No theme guards — link href may be full URL. */
  function initSizeGuideDeepLink() {
    function scrollToFitGuideSection() {
      const el =
        document.getElementById('pdp_size_guide') ||
        document.getElementById('pdp-size-guide') ||
        document.querySelector('.collapsible-tabs__tab--fit-guide') ||
        document.querySelector('[data-fit-guide-scroll-target]');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const details = el.querySelector('details.disclosure');

        if (details && !details.hasAttribute('open')) {

          details.setAttribute('open', '');

        }
        return true;
      }
      return false;
    }

    function handleSizeGuideClick(e) {
      const a = e.target.closest(
        'a.sr-pdp-size-guide-link, a[href*="#pdp_size_guide"], a[href*="#pdp-size-guide"], a[href*="pdp_size_guide"], a[href*="pdp-size-guide"]'
      );
      if (!a) return;
      // Only intercept when we can scroll to a real target. Otherwise default #hash may still help.
      if (scrollToFitGuideSection()) {
        e.preventDefault();
      }
    }

    document.addEventListener('click', handleSizeGuideClick, true);

    if (window.location.hash === '#pdp_size_guide' || window.location.hash === '#pdp-size-guide') {
      requestAnimationFrame(scrollToFitGuideSection);
    }
  }

  /**
   * Replace only the "Features" accordion title within the SR PDP description accordion.
   * This content can be hydrated/re-rendered after DOMContentLoaded, so we observe mutations
   * and apply once when it appears (or re-appears).
   */
  function replacePdpFeaturesTitle() {
    const ROOT_SELECTOR = '#product_wrapper-container.sr-pdp, .sr-pdp';
    const TARGET_SUMMARY_SELECTOR =
      '.acc-pdp-description.product-info-accordion summary.disclosure__title';

    function doSwap() {
      const root = document.querySelector(ROOT_SELECTOR);
      if (!root) return false;

      const summary = root.querySelector(TARGET_SUMMARY_SELECTOR);
      if (!summary) return false;

      // Only replace direct text node (ignore chevron span)
      const directTextNode = Array.from(summary.childNodes).find(
        (n) => n.nodeType === Node.TEXT_NODE && n.nodeValue.trim().length
      );
      if (!directTextNode) return false;

      const current = directTextNode.nodeValue.trim();
      if (current === 'PRODUCT INFORMATION') return true;
      if (current !== 'Features') return false;

      directTextNode.nodeValue = 'PRODUCT INFORMATION';
      return true;
    }

    // Try immediately
    if (doSwap()) return;

    // Observe hydration/rerenders; disconnect after success (or timeout)
    const obs = new MutationObserver(() => {
      if (doSwap()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 10000);
  }

  function init() {
    apply();
    window.matchMedia(MQ).addEventListener('change', apply);

    document.querySelectorAll('.collapsible-tabs__tab--fit-guide details.disclosure').forEach((details) => {
      details.setAttribute('open', '');
    });

    initFitGuidePill();
    initSizeGuideDeepLink();
    initYotpoTitleRowReviewsScroll();
    replacePdpFeaturesTitle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Normalizes Yotpo review scores to ensure a single decimal point (e.g., 5 becomes 5.0).
 * Uses the official Yotpo ready callback to handle asynchronous widget loading.
 */
window.yotpoWidgetsContainer = window.yotpoWidgetsContainer || {};
window.yotpoWidgetsContainer.readyCallback = function() {
  const scoreElements = document.querySelectorAll('.yotpo-bottom-line-score');
  
  scoreElements.forEach(element => {
    const score = parseFloat(element.textContent);
    
    if (!isNaN(score)) {
      element.textContent = score.toFixed(1);
    }
  });
};